import React from 'react'

import { ArrowDirectionIcon } from '@application/Interfaces/Icons'
import { SubTitleDescriptionCTAImageItemType, ThemeModeType } from '@application/Types/ComponentTypes'

import { Description, GetStarted, Title, Wrapper } from './Details.styled'

type AppScreenshotDetailsProps = Pick<
    SubTitleDescriptionCTAImageItemType,
    'title' | 'description' | 'viewMore' | 'viewMoreLinkLabel'
> & {
    mode: ThemeModeType
}

export const Details = (props: AppScreenshotDetailsProps): JSX.Element => {
    const { title, description, viewMore, viewMoreLinkLabel, mode } = props

    return (
        <Wrapper $mode={mode}>
            <Title>{title}</Title>
            {description && <Description>{description}</Description>}
            {viewMoreLinkLabel && viewMore && (
                <GetStarted to={viewMore}>
                    <span>{viewMoreLinkLabel}</span>
                    <ArrowDirectionIcon colorCode="p500" />
                </GetStarted>
            )}
        </Wrapper>
    )
}
